import { BaseError } from './BaseError';
import lock from 'assets/images/lock.svg';

const errorLargeKey = 'error.forbidden_error.large_text';
const errorSmallKey = 'error.forbidden_error.small_text';

export const ForbiddenError = () => (
    <BaseError
        iconUrl={lock}
        errorCode={403}
        keyLarge={errorLargeKey}
        keySmall={errorSmallKey}></BaseError>
);
